import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './LineLoader.module.scss'

const BAR_COUNT = 5 // Keep in sync with scss until we have json wired in

// Ahead of time for slight render performance
const BARS = new Array(BAR_COUNT)
  .fill()
  .map((_, i) => <div key={`lineScale_${i}`} />)

const LineLoader = ({ className }) => (
  <div className={classnames(styles.lineScale, className)}>{BARS}</div>
)

LineLoader.propTypes = {
  className: PropTypes.string,
}

export default LineLoader
